import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { lookupsJson } from '@ourbranch/lookups';
import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import { FormField } from 'core/components/form';
import warning from 'core/assets/svg/warning.svg';
import useStyles from '../../../dialog.styles';

export const DriversLicenseCard = observer(function DriversLicenseCard({ driver, index }) {
  const classes = useStyles();
  return (
    <Card type="quatrinary" className={classes.mvrDriversCard}>
      <Grid container item xs={12} alignItems="center">
        <img src={warning} alt="" />
        <Label type="infoSubtitleWhite" style={{ marginLeft: '8px' }}>
          {driver.firstName} {driver.lastName}
        </Label>
      </Grid>
      <Grid container item spacing={5}>
        <FormField
          type="select"
          name={`drivers[${index}].driversLicenseState`}
          label="Drivers License State"
          options={lookupsJson.usStates}
          mode="light"
          xs={6}
        />
        <FormField
          type="string"
          name={`drivers[${index}].driversLicenseNumber`}
          label="Drivers License Number"
          placeholder="eg: ABCD12345"
          mode="light"
          xs={6}
        />
      </Grid>
    </Card>
  );
});
